import React from 'react';
import { LinkDescriptor, useMatches } from 'react-router';

export function DynamicLinks() {
  let links: LinkDescriptor[] = useMatches().flatMap((match:any) => {
    let fn =  match.handle?.dynamicLinks
    if (typeof fn !== "function") return [];
    return fn({ data: match.data });
  });

  return (
    <React.Fragment>
      {links.map((link) => (
        <link {...link} key={link?.integrity ||  JSON.stringify(link)} />
      ))}
    </React.Fragment>
  );
}

